function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.define-property.js";
import { initCarousel } from "../../objects/carousel";
import { responsiveQuery } from './../../settings/responsive';
var SEL_CONTAINER = '[data-product-carousel-container]';
var SEL_CAROUSEL = '[data-carousel]'; // const BUTTON_PREV = '[data-products-carousel-prev]';

var BUTTON_NEXT = '[data-carousel-next]';
var SELECTOR_CAROUSEL_PROGRESS = '[data-carousel-progress]';
document.querySelectorAll(SEL_CONTAINER).forEach(function (container) {
  var _breakpoints;

  var carousel = container.querySelector(SEL_CAROUSEL); // const prev = container.querySelector<HTMLDivElement>(BUTTON_PREV);

  var next = container.querySelector(BUTTON_NEXT);
  var progressBar = container.querySelector(SELECTOR_CAROUSEL_PROGRESS);
  if (!carousel || !next || !progressBar) return;
  initCarousel(carousel, {
    loop: true,
    slidesPerView: 1.6,
    //spacing: 4,
    breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, responsiveQuery('SMALL'), {
      slidesPerView: 3
    }), _defineProperty(_breakpoints, responsiveQuery('LARGE'), {
      slidesPerView: 4
    }), _breakpoints)
  }, undefined, undefined, next, undefined, progressBar);
});